
export const DateFilter  = v => v ?
  new Date(v).toLocaleString() :
  '-'

export const CountFilter = v => (v || []).length
